import { createSlice } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';

const pricingSlice = createSlice({
    name: 'pricing',
    initialState: {
        isOpen: false,
        activeTab: '0',
    },
    reducers: {
        openPricingDialog: (state) => {
            state.isOpen = true;
        },
        closePricingDialog: (state) => {
            state.isOpen = false;
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(REHYDRATE, (state, action) => {
            state.isOpen = false;
            if (action.payload?.pricing?.activeTab) {
                state.activeTab = action.payload.pricing.activeTab;
            }
        });
    },
});

export const { openPricingDialog, closePricingDialog, setActiveTab } = pricingSlice.actions;
export default pricingSlice.reducer;